export const getShopType = [
    {
      "id": 1,
      "mccCode": 4215,
      "mccDescription": "Courier services — air and ground and freight forwarders"
    },
    {
      "id": 2,
      "mccCode": 4722,
      "mccDescription": "Travel agencies and tour operators"
    },
    {
      "id": 3,
      "mccCode": 4789,
      "mccDescription": "Transportation services "
    },
    {
      "id": 4,
      "mccCode": 4812,
      "mccDescription": "Telecommunication equipment and telephone sales"
    },
    {
      "id": 5,
      "mccCode": 4814,
      "mccDescription": "Telecommunication services, including local and long distance calls"
    },
    {
      "id": 6,
      "mccCode": 4816,
      "mccDescription": "Computer network/information services"
    },
    {
      "id": 7,
      "mccCode": 4900,
      "mccDescription": "Utilities — electric, gas, water and sanitary"
    },
    {
      "id": 8,
      "mccCode": 5099,
      "mccDescription": "Durable goods"
    },
    {
      "id": 9,
      "mccCode": 5111,
      "mccDescription": "Stationery, office supplies and printing and writing paper"
    },
    {
      "id": 10,
      "mccCode": 5137,
      "mccDescription": "Men’s, women’s and children’s uniforms and commercial clothing"
    },
    {
      "id": 11,
      "mccCode": 5192,
      "mccDescription": "Books, periodicals and newspapers"
    },
    {
      "id": 12,
      "mccCode": 5193,
      "mccDescription": "Florists’ supplies, nursery stock and flowers"
    },
    {
      "id": 13,
      "mccCode": 5199,
      "mccDescription": "Non-durable goods"
    },
    {
      "id": 14,
      "mccCode": 5311,
      "mccDescription": "Department Stores"
    },
    {
      "id": 15,
      "mccCode": 5331,
      "mccDescription": "Variety Stores"
    },
    {
      "id": 16,
      "mccCode": 5411,
      "mccDescription": "Groceries and supermarkets"
    },
    {
      "id": 17,
      "mccCode": 5451,
      "mccDescription": "Dairies"
    },
    {
      "id": 18,
      "mccCode": 5462,
      "mccDescription": "Bakeries"
    },
    {
      "id": 19,
      "mccCode": 5533,
      "mccDescription": "Automotive parts and accessories outlets"
    },
    {
      "id": 20,
      "mccCode": 5651,
      "mccDescription": "Family clothing shops"
    },
    {
      "id": 21,
      "mccCode": 5655,
      "mccDescription": "Sports and riding apparels"
    },
    {
      "id": 22,
      "mccCode": 5661,
      "mccDescription": "Shoe shops"
    },
    {
      "id": 23,
      "mccCode": 5722,
      "mccDescription": "Household appliance shops"
    },
    {
      "id": 24,
      "mccCode": 5732,
      "mccDescription": "Electronics Shops"
    },
    {
      "id": 25,
      "mccCode": 5734,
      "mccDescription": "Computer software outlets"
    },
    {
      "id": 26,
      "mccCode": 5814,
      "mccDescription": "Fast food restaurants"
    },
    {
      "id": 27,
      "mccCode": 5942,
      "mccDescription": "Bookshops"
    },
    {
      "id": 28,
      "mccCode": 5943,
      "mccDescription": "Stationery, office and school supply shops"
    },
    {
      "id": 29,
      "mccCode": 5947,
      "mccDescription": "Gift, card, novelty and souvenir shops"
    }
  ]